// src/components/admin/AdminProductCard.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Product } from '../../types';

interface AdminProductCardProps {
  product: Product;
  onFix: (product: Product) => void;
}

const AdminProductCard: React.FC<AdminProductCardProps> = ({ product, onFix }) => {
  // Проверяем обязательные поля
  const missingName = !product.name || product.name.trim() === "";
  const missingCategory = !product.category || !product.category.name || product.category.name.trim() === "";
  // Если бренд не выбран, проверяем либо поле brand_id либо объект product.brand
  const missingBrand = (!product.brand_id || product.brand_id === 0);
  const missingPrice = product.price <= 0;
  const missingSKU = !product.sku || product.sku.trim() === "";
  const missingDescription = !product.description || product.description.trim() === "";
  const missingImage = !product.cover_image || product.cover_image.trim() === "";

  // Собираем список недостающих полей
  const missingFields: string[] = [];
  if (missingName) missingFields.push("Наименование");
  if (missingCategory) missingFields.push("Категория");
  if (missingBrand) missingFields.push("Бренд");
  if (missingPrice) missingFields.push("Цена");
  if (missingSKU) missingFields.push("Штрихкод");
  if (missingDescription) missingFields.push("Описание");
  if (missingImage) missingFields.push("Изображение");

  const isIncomplete = missingFields.length > 0;

  return (
    <div className="relative block p-4 rounded shadow">
      {/* Основное содержимое карточки, которое размывается при отсутствии данных */}
      <div className={`${isIncomplete ? 'filter blur-sm' : ''}`}>
        <div className="relative mb-4 h-[245px]">
          {product.cover_image && product.cover_image.trim() !== "" ? (
            <img
              src={product.cover_image}
              alt={product.name}
              className="w-full h-full object-contain"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gray-200">
              Нет изображения
            </div>
          )}
        </div>
        <div>
          {product.category && product.category.name && (
            <h4
              className="text-sm text-gray-500 truncate uppercase"
              title={product.category.name}
            >
              {product.category.name}
            </h4>
          )}
          <h3
            className="font-bold text-lg line-clamp-1 mt-1"
            title={product.name}
          >
            {product.name}
          </h3>
          <div className="flex items-center space-x-2 mt-2">
            <span className="text-xl font-bold">{product.price} ₸</span>
          </div>
        </div>
        <div className="flex justify-between mt-4">
          <button className="py-2 px-2 border bg-white/50 text-black rounded hover:bg-white-800" onClick={() => onFix(product)}>
            Редактировать
          </button>
          <Link to={`/product/${product.id}`}>
            <button className="py-2 px-2 bg-[#2C2C2C] text-white rounded hover:bg-gray-800">
              Открыть
            </button>
          </Link>
        </div>
      </div>

      {/* Оверлей, если данные не заполнены */}
      {isIncomplete && (
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-60">
          <div className="text-center text-white font-bold text-lg px-2">
            Недостающие данные:
            <br />
            {missingFields.join(', ')}
          </div>
          <button
            className="mt-4 py-2 px-2 border bg-white/50 text-black rounded hover:bg-gray-800"
            onClick={() => onFix(product)}
          >
            Исправить
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminProductCard;
